import React from "react"
import { MuiThemeProvider } from "@material-ui/core"
import Footer from "components/Footer"
import Hero from "components/Hero"
import AboutMe from "components/AboutMe"
import MyBlog from "components/MyBlog"
import MySharedProduct from "components/MySharedProduct"
import SEO from "components/gatsby/SEO"
import { themeColor } from "services/constants"

interface Props {}

const App: React.FC<Props> = () => {
  return (
    <MuiThemeProvider theme={themeColor}>
      <SEO title="Home" />
      <Hero />
      <AboutMe />
      <MyBlog />
      <MySharedProduct />
      <Footer />
    </MuiThemeProvider>
  )
}

export default App
